import React from "react"

const DownIcon = () => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99844 6.67502C5.88177 6.67502 5.76944 6.65403 5.66144 6.61203C5.55277 6.57069 5.45677 6.50836 5.37344 6.42502L0.873437 1.92502C0.723437 1.77503 0.648438 1.60002 0.648438 1.40002C0.648438 1.20002 0.723437 1.02502 0.873437 0.875025C1.02344 0.725025 1.19844 0.650024 1.39844 0.650024C1.59844 0.650024 1.77344 0.725025 1.92344 0.875025L5.99844 4.95002L10.0734 0.875025C10.2234 0.725025 10.3984 0.650024 10.5984 0.650024C10.7984 0.650024 10.9734 0.725025 11.1234 0.875025C11.2734 1.02502 11.3484 1.20002 11.3484 1.40002C11.3484 1.60002 11.2734 1.77503 11.1234 1.92502L6.62344 6.42502C6.5401 6.50836 6.44444 6.57069 6.33644 6.61203C6.22777 6.65403 6.1151 6.67502 5.99844 6.67502Z"
        fill="#ffffff"
      ></path>
    </svg>
  )
}
export default DownIcon
